/* eslint-disable no-underscore-dangle */
import translations from './locales';
import url from '../utils/url';

/**
 * Isomorphic gettext
 * @param {String} key key of string.
 * @return {String}
 */
export default function gettext(key) {
  const trans = translations[key];
  let lang = 'en';

  switch (url.getRegion()) {
    case 'CN':
      lang = 'zh';
      break;
    default:
      lang = 'en';
      break;
  }

  if (!trans) {
    return key;
  }

  return trans[lang];
}
